import { Redirect } from '@reach/router'
import { forEachObjIndexed } from 'ramda'
import React from 'react'

import { useLocation } from '../../utils/contexts/UrlProvider'

const RedirectWithParams = ({ path, to, ...props }) => {
  const { search } = useLocation() || {}
  let newPath = to + search

  forEachObjIndexed((value, key) => {
    newPath = newPath.replace(':' + key, value)
  }, props)

  return <Redirect from={path} to={newPath} noThrow />
}

export default RedirectWithParams
